import type { MessageFilePayload } from 'models';
import { Attachments } from 'ui';
import { useGetMediaSource } from 'features/media';
import type { MessageDirection } from '../../../types';

type P = {
  direction: MessageDirection;
  files: MessageFilePayload[];
};

const ChatMessageBubbleAttachments = ({ direction, files }: P) => {
  const getMediaSource = useGetMediaSource();

  return (
    <Attachments
      attachments={files.map((file) => ({
        contentType: file.meta.mimeType,
        filename: file.meta.name,
        id: file.ref,
        url: getMediaSource({ id: file.ref }),
      }))}
      columns={files.length === 1 ? 1 : 2}
      variant={direction === 'incoming' ? 'light' : 'inverted'}
    />
  );
};

export default ChatMessageBubbleAttachments;
